module.exports = __webpack_public_path__ + "img/vistorManagement.f87c5542.svg";